/*
  ShopApiService class
  店舗向けAPI通信
 */
import ApiBase, { HTTP_METHOD as METHOD } from 'js/shared/api-base';
import { shopInfoMapper } from 'js/shop/components/ShopInfoContext';
import moment from 'moment';
/*
 * Endpoint情報
 *
 * 各Keyごとに以下の順の1次元配列で指定する
 * [url, method, needAuth]
 * url {string} 変数は$0, $1, $2指定
 * method {string}
 * needauth {boolean}
 * options {Object}
 */

export const ENDPOINTS = {
  // 新規登録＞採番・店舗名登録 shop/ : POST
  REGIST_SHOP: ['shop', METHOD.POST, true],
  // 新規登録＞店舗情報取得 shop/{shop} : GET
  GET_SHOP: ['shop/$0', METHOD.GET, true],

  POST_CREATE_SHOP_TMP: ['shop', METHOD.POST, true],

  REGISTER_DEACTIVATE_SHOP: ['shop/$0/copy', METHOD.POST, true],

  // 新規登録＞店舗情報登録 shop/{shop} : PUT
  UPDATE_SHOP: ['shop/$0', METHOD.PUT, true],
  // 新規登録＞郵便番号検索 address/zip/{zip_code} : GET
  SEARCH_ZIP: ['address/zip/$0', METHOD.GET, false],
  // 新規登録＞緯度経度取得 address/geo/{address} : GET
  GET_LATLON: ['address/geo/$0', METHOD.GET, false],

  // 新規登録＞SHOPのジャンル登録
  REGIST_SHOPGENRE: ['shop/$0/genre', METHOD.POST, true],
  // SHOPのジャンル更新
  UPDATE_SHOPGENRE: ['shop/$0/genre', METHOD.PUT, true],

  // ====
  // TODO
  // ====

  // 新規登録＞ジオコーディング address/geo/{address} : GET
  // 新規登録＞ジャンル取得 genre/ : GET
  GET_GENRE: ['genre/', METHOD.GET, false],
  // (保留？) 新規登録＞暗証番号設定 shop/passcodeenroll : POST
  // (保留？) 店舗ログイン送信 shop/login : POST
  // (保留？) 暗証番号リセット shop/passcodereset : POST
  // 弁当登録＞弁当ID登録 shop/{shop}/item : POST
  REGIST_ITEM: ['shop/$0/item', METHOD.POST, true],

  // 弁当登録＞画像登録 shop/{shop}/item/{item}/images : POST # encType="multipart/form-data"
  REGIST_ITEM_IMG: ['shop/$0/item/$1/images', METHOD.POST_FILE, true],

  // 弁当登録＞弁当情報更新 shop/{shop}/item/{item} : PUT
  // 弁当登録＞販売ステータス変更 shop/{shop}/item/{item} : PUT
  UPDATE_ITEM: ['shop/$0/item/$1', METHOD.PUT, true],

  // 販売中弁当情報取得（店舗別） shop/{shop}/item : GET
  GET_ITEMS: ['shop/$0/item', METHOD.GET, true],

  // 弁当削除
  DELETE_ITEM: ['shop/$0/item/$1', METHOD.DELETE, true],

  //get all payment method
  GET_PAYMENT_METHODS: ['shop/$0/payment-methods-for-cus', METHOD.GET, true],

  //post shop tax info
  POST_SHOP_TAX_INFO: ['shop/$0/tax', METHOD.POST, true],

  //get shop tax info
  GET_SHOP_TAX_INFO: ['shop/$0/tax', METHOD.GET, true],

  //get tax options
  GET_TAX_OPTIONS: ['shop/$0/tax-options', METHOD.GET, true],

  // 弁当サムネイル画像取得 /img/{shop}/{item}/photo_s : GET
  // 弁当画像取得 /img/{shop}/{item}/photo_l : GET
  // 人通り数・ウォッチユーザ数取得 shop/{shop}/watchusers : GET
  // 分析＞分析情報取得 statistics/shop/{shop} : GET
  // 分析＞分析情報取得 statistics/shop/{shop}/item/{item?} : GET
  // GPS情報取得 user/gps : GET
  // 近隣店舗情報取得 user/area?sw_lat=xxx&sw_lon=xxx&ne_lat=xxx&ne_lon : GET
  // 販売中弁当情報取得（店舗別） item/available : POST
  // 弁当サムネイル画像取得 item/images : GET
  // 人通り情報送信 user/passbyinfo : POST
  // 販売中弁当情報取得（店舗別） shop/items : POST
  // 弁当画像取得 /item/image : GET

  // GET service_plans of system
  GET_SERVICE_PLANS: ['shop/service-plans', METHOD.GET, true],
  UPDATE_SERVICE_PLAN_OF_SHOP: ['shop/$0/setting/service-plan', METHOD.POST, true],
  CANCEL_CONTRACT_OF_SHOP: ['shop/$0/cancel-contract', METHOD.POST, true],
};

class ShopApiService extends ApiBase {
  constructor(param) {
    super(param);
  }

  // TODO: 必要ならoverride
  // request(endpointArray, data) {
  //   super.request(endpointArray, data).then((response) => {
  //     return response;
  //   });
  // }

  /*
   * 店舗、ジャンル登録の一連の処理を行い、割り当てられた hash_id を返す
   * @param <Object> shopInfo
   * @return <Promise<string>> m_shop.hash_id
   */
  registShop(shop) {
    if (!shop || shop.name === '') {
      console.error('[ShopApiservice] registShop() ERROR: no shop-data');
      throw new Error('no-shop-data');
    }

    const registData = shopInfoMapper.toDB(shop);
    console.debug('[ShopApiservice] registShop() registData ', registData);
    const genreArray = Array.isArray(registData.genre) ? [...registData.genre] : [];
    delete registData.genre;
    console.debug('[ShopApiService] registShop() genreArray', genreArray);
    let dbShopResult = null;

    // 店舗情報の緯度経度を取得
    return this.request(
      ENDPOINTS.GET_LATLON,
      [registData.prefecture + registData.city + registData.address + registData.building],
      null
    ).then((latlngResult) => {
      console.debug('[ShopApiservice] GET_LATLON', latlngResult);
      registData.lat = latlngResult.lat;
      registData.lon = latlngResult.lng;
      // 店舗情報とジャンルは別に２段階でリクエスト
      return this.request(ENDPOINTS.REGIST_SHOP, null, registData)
        .then((shopResult) => {
          console.debug('[ShopApiservice] REGIST_SHOP', shopResult);
          dbShopResult = shopResult;
          return this.request(ENDPOINTS.REGIST_SHOPGENRE, [shopResult.hash_id], {
            genre: genreArray,
          });
        })
        .then((genreResult) => {
          console.debug('[ShopApiservice] REGIST_SHOPGENRE', genreResult);
          return dbShopResult.hash_id;
        });
    });
  }

  /*
   * Create shop tmp api
   * @param {object} data
   * @param {string} data.name
   * @param {string} data.email
   * @param {string} data.phone_number
   * @param {string} data.address
   * @param {string} data.postal_code
   * @param {string} data.prefecture
   * @param {string} data.start_time
   * @param {string} data.end_time
   * @param {string} data.city
   * @param {string} data.genre
   */
  async createShopTemp(data = {}) {
    return await this.request(ENDPOINTS.POST_CREATE_SHOP_TMP, [], data);
  }

  /*
   * 店舗情報取得
   * @param <string> hashId: shop hash id
   * @return <Promise<string>> m_shop.hash_id
   */
  getShop(hashId = null) {
    const hash = [];
    if (hashId) {
      hash.push(hashId);
    }
    return this.request(ENDPOINTS.GET_SHOP, hash, null).then((result) => {
      if (!Array.isArray(result)) {
        throw Error('invalid response(GET_SHOP)');
      }
      const shop = result.pop();
      console.debug('[API] getShop() shop', shop);
      if (!shop) {
        return null; // 未登録
      } else if (shop.hash_id && shop.hash_id.length > 0) {
        return shopInfoMapper.fromDB(shop);
      } else {
        throw Error('invalid response(GET_SHOP)');
      }
    });
  }

  /*
   * Register Shop that is deactivate
   * @param <string> shopHashId
   * @return <Promise<object>> m_shop
   */
  async registerDeactivateShop(shopHashId) {
    return await this.request(ENDPOINTS.REGISTER_DEACTIVATE_SHOP, [shopHashId], {});
  }

  /*
   * 弁当の販売状態切替
   * @param <string> shopHash: shop hash id
   * @param <string> itemHash: item hash id
   * @param <boolean> isOnsale: 変更後のonsale 状態
   * @return <Promise<string>>  変更結果
   */
  toggleOnsale(shopHash, itemHash, isOnsale) {
    const params = [];
    if (shopHash) {
      params.push(shopHash);
    }
    if (itemHash) {
      params.push(itemHash);
    }
    return this.request(ENDPOINTS.UPDATE_ITEM, params, {
      status: isOnsale ? 'onsale' : 'not_onsale',
    }).then((result) => {
      return result.status;
    });
  }

  /*
   * 指定アイテムの取得
   * @param <string> shopHash: shop hash id
   * @param <string> itemHash: item hash id
   * @return <Promise<Obento>> アイテムを返す
   */
  getItem(shopHash, itemHash) {
    //
    // TODO : 店舗分一括で取得しているが、指定したアイテムのデータだけ取得するAPIが欲しい
    //
    return this.request(ENDPOINTS.GET_ITEMS, [shopHash], null).then((result) => {
      if (result && Array.isArray(result)) {
        const target = result.find((item) => item.hash_id === itemHash);
        return target;
      } else {
        return null;
      }
    });
  }

  /*
   * 指定アイテムの削除
   * @param <string> shopHash: shop hash id
   * @param <string> itemHash: item hash id
   * @return <Promise<boolean>>
   */
  deleteItem(shopHash, itemHash) {
    //
    // TODO : （確認）削除専用のAPIが無い？
    //
    return this.request(ENDPOINTS.DELETE_ITEM, [shopHash, itemHash], {
      deleted_at: moment().format('YYYY-MM-DD HH:mm:ss'),
    }).then((result) => {
      console.debug('[shop-api-service] deleteItem() result', result);
      return result;
    });
  }

  updateShop(shopHash, data) {
    return this.request(ENDPOINTS.UPDATE_SHOP, [shopHash], data)
      .then(result => {
        return shopInfoMapper.fromDB(result);
      });
  }

  getGenre() {
    return this.request(ENDPOINTS.GET_GENRE)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }

  updateShopGenre(shopHash, data) {
    return this.request(ENDPOINTS.UPDATE_SHOPGENRE, [shopHash], data)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }

  async getServicePlans() {
    return await this.request(ENDPOINTS.GET_SERVICE_PLANS);
  }

  async updateServicePlanOfShop(shopHashId, servicePlanId) {
    return await this.request(ENDPOINTS.UPDATE_SERVICE_PLAN_OF_SHOP, [shopHashId], {service_plan_id: servicePlanId});
  }

  /**
   * Cancel contract of shop
   * @param {string} shopHashId
   */
   async cancelContractShop(shopHashId) {
    return await this.request(ENDPOINTS.CANCEL_CONTRACT_OF_SHOP, [shopHashId], {});
  }

  async getLatLon(prefecture, city, address, building) {
    return await this.request(ENDPOINTS.GET_LATLON, [prefecture + city + address + building], null);
  }

  /*
   * Get all payment methods
   * @param {string} shopHash: shop hash id
   */
  async getPaymentMethods(shopHash) {
    return await this.request(ENDPOINTS.GET_PAYMENT_METHODS, [shopHash], null);
  }
  
  /*
   * Post shop tax info
   * @param {string} shopHash: shop hash id
   * @param {Object} data
   */
  async postShopTaxInfo(shopHash, data) {
    return await this.request(ENDPOINTS.POST_SHOP_TAX_INFO, [shopHash], data);
  }

  /*
   * Get shop tax info
   * @param {string} shopHash: shop hash id
   */
  async getShopTaxInfo(shopHash) {
    return await this.request(ENDPOINTS.GET_SHOP_TAX_INFO, [shopHash], null);
  }

   /*
   * Get tax options
   * @param {string} shopHash: shop hash id
   */
   async getTaxOptions(shopHash) {
    return await this.request(ENDPOINTS.GET_TAX_OPTIONS, [shopHash], null);
  }
}

// singleton
export default new ShopApiService();
